/* FUSIFY – gedeelde interactie voor de .fzx-landingspagina's: voortgangsbalk, actieve inhoudsopgave, inschuiven, tabs, schuiven, keuzeknoppen, sticky CTA. */
(function(){
  var root=document.querySelector('.fzx');if(!root)return;
  var raf=window.requestAnimationFrame||function(f){setTimeout(f,16)};

  // voortgangsbalk + sticky CTA
  var prog=root.querySelector('.fzx-prog'),art=root.querySelector('.fzx-art'),sticky=root.querySelector('.fzx-sticky'),hero=root.querySelector('.fzx-hero'),slot=root.querySelector('.fzx-slot');
  function scroll(){
    if(prog&&art){var r=art.getBoundingClientRect(),t=Math.min(1,Math.max(0,-r.top/(r.height-innerHeight*.6)));prog.style.transform='scaleX('+t+')'}
    if(sticky&&hero){var voorbij=hero.getBoundingClientRect().bottom<0,bijSlot=slot&&slot.getBoundingClientRect().top<innerHeight;sticky.classList.toggle('op',voorbij&&!bijSlot)}
  }
  var wacht=false;addEventListener('scroll',function(){if(!wacht){wacht=true;raf(function(){scroll();wacht=false})}},{passive:true});scroll();

  // actieve inhoudsopgave
  var links=[].slice.call(root.querySelectorAll('.fzx-toc a[href^="#"]'));
  if(links.length&&'IntersectionObserver'in window){
    var kop={};links.forEach(function(a){var el=document.getElementById(a.getAttribute('href').slice(1));if(el)kop[el.id]=a});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){links.forEach(function(a){a.classList.remove('on')});kop[e.target.id]&&kop[e.target.id].classList.add('on')}})},{rootMargin:'-20% 0px -70% 0px'});
    Object.keys(kop).forEach(function(id){io.observe(document.getElementById(id))});
  }
  // mobiel: inhoudsopgave sluiten na klik
  links.forEach(function(a){a.addEventListener('click',function(){var d=a.closest('details');if(d&&innerWidth<=1020)d.open=false})});

  // inschuiven
  var rv=[].slice.call(root.querySelectorAll('[data-rv]'));
  if('IntersectionObserver'in window){var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io2.unobserve(e.target);vulBalken(e.target)}})},{rootMargin:'0px 0px -8% 0px'});rv.forEach(function(el){io2.observe(el)})}
  else rv.forEach(function(el){el.classList.add('in')});
  function vulBalken(el){[].forEach.call(el.querySelectorAll('.fzx-bar i[data-w]'),function(i){i.style.width=i.getAttribute('data-w')})}

  // tabs
  [].forEach.call(root.querySelectorAll('.fzx-tabs'),function(t){
    var tabs=[].slice.call(t.querySelectorAll('[role=tab]'));
    tabs.forEach(function(b,i){b.addEventListener('click',function(){
      tabs.forEach(function(x){x.setAttribute('aria-selected',x===b);var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=x!==b});
    });b.addEventListener('keydown',function(e){var n=e.key==='ArrowRight'?1:e.key==='ArrowLeft'?-1:0;if(n){var j=(i+n+tabs.length)%tabs.length;tabs[j].focus();tabs[j].click()}})});
  });

  // schuiven: kleur tot de duim
  function vul(r){var p=(r.value-r.min)/(r.max-r.min)*100;r.style.setProperty('--p',p+'%')}
  [].forEach.call(root.querySelectorAll('input[type=range]'),function(r){vul(r);r.addEventListener('input',function(){vul(r)})});

  // keuzeknoppen: [data-keuze] groep, één actief
  [].forEach.call(root.querySelectorAll('.fzx-keuze[data-keuze]'),function(g){
    g.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;
      [].forEach.call(g.querySelectorAll('button'),function(x){x.setAttribute('aria-pressed',x===b)});
      g.dispatchEvent(new CustomEvent('fzxkeuze',{bubbles:true,detail:{groep:g.getAttribute('data-keuze'),waarde:b.getAttribute('data-v')}}));
    });
  });

  // mobiel: hero-illustratie onder de productregels, zodat de producten boven de vouw staan
  if(innerWidth<750){var pr=root.querySelector('.fzx-hero .fzx-prods');
    if(pr)[].forEach.call(root.querySelectorAll('.fzx-hero .hp-huis,.fzx-hero .dl-twist,.fzx-hero .lb-split,.fzx-hero .eo-still,.fzx-hero .gm-lobby'),function(el){el.setAttribute('data-mob-onder','');pr.parentNode.insertBefore(el,pr.nextSibling)});}

  // hulpfuncties voor paginascripts
  window.FZX={
    keuze:function(groep){var b=root.querySelector('.fzx-keuze[data-keuze="'+groep+'"] [aria-pressed=true]');return b?b.getAttribute('data-v'):null},
    flash:function(el){el.classList.remove('fzx-flash');void el.offsetWidth;el.classList.add('fzx-flash')},
    euro:function(n){return '€'+n.toFixed(2).replace('.',',')},
    vulBalken:vulBalken
  };
})();
